import { _ToNormal, setDate } from "../../Utils/helper";


import { smallDown } from 'react-icons-kit/entypo/smallDown'
import { smallUp } from 'react-icons-kit/entypo/smallUp'
import { ic_expand_more } from 'react-icons-kit/md/ic_expand_more'; // Greyed-out icon
import { ic_expand_less } from 'react-icons-kit/md/ic_expand_less';
import Icon from "react-icons-kit";
import { useState } from "react";
import ReactPortalModal from "../../components/ReactPortalModal";
import { useSelector } from "react-redux";

const Records = ({ lable, data, sortBy, orderBy, setOrder }) => {

    const [invoicePreview, setPreview]=useState(null)
    const User=useSelector(state=>state.User)
      const DocPreview = () => {
        var loading = {
          padding: "1rem",
          height: "10vh",
          width: "-webkit-fill-available",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
        if (!invoicePreview) {
          return (<div style={loading}>
            {"Error in generating PDF"}
          </div>)
        }
        else {
          return (
            <embed
              id="pdf-viewer"
              src={invoicePreview + "#toolbar=0"}
              type="application/pdf"
              style={{width:"50rem"}}
            />
          )
        }
      }
      
    return (
        <>
            <div className="credentials-table">
                <table>
                    <tr className="credentials-header bg-lgray">
                        {lable.map((heading, index) =>
                        User.user_type=="Issuer" &&  (heading === "payment_method" || heading === "wallet_balance")?null:
                            <th className="credentials-th" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }} key={index}>
                                <div className="credentials-table-text">{_ToNormal(heading)}</div>
                                <div onClick={() => setOrder(index)} style={{ cursor: 'pointer' }}>
                                    {index === sortBy ?
                                        <Icon icon={orderBy ? smallUp : smallDown} size={'1.2rem'} /> :
                                        <Icon icon={smallDown} style={{ color: 'var(--gray-400)' }} />
                                    }
                                </div>
                            </th>)}
                        {User.user_type=="Verifier"&&    <th className="credentials-th" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                <div className="credentials-table-text">Action</div>
                                <div  style={{ cursor: 'pointer' }}>
                                </div>
                            </th>}
                    </tr>
                    {data.length === 0 ?
                        <tr className="credentials-tr">
                            <td colSpan="6" className="credentials-td text-center">
                                <div className="Data_List">No Record Found</div>
                            </td>
                        </tr>
                        :
                        <>
                            {data.map((i, index) => {

                                // let Actions = () => {
                                //     if (state == 'DRAFT') {
                                //         return (
                                //             <div title="Draft" className="eye-icon" >
                                //                 <Link to="/dashboard/credentials/issue-credentials" state={{ data: i.doc_field, isNew: true, step: 4 }}>
                                //                     <img src="/editoutline.svg" alt="editoutline.svg" className="edit" />
                                //                 </Link>
                                //             </div>
                                //         )
                                //     }
                                //     if (state == 'change_requested' || state == 'accepted' || state == 'rejected') {
                                //         return (
                                //             <div title="Draft" className="eye-icon" >
                                //                 <Link to={`/dashboard/change-request/${i.doc_field?.details?.discrepancy_ticket_id}`} state={{ data: i.doc_field, isNew: true }} className="link">
                                //                     <Icon icon={androidOpen} size={'1rem'} />
                                //                     View
                                //                 </Link>
                                //             </div>
                                //         )
                                //     }
                                //     if (state == 'PUBLISHED') {
                                //         return (
                                //             <div style={{ display: "flex", flexDirection: "row" }}>
                                //                 <div className="eye-icon" title=" View Document">
                                //                     <img alt="" src="/eyeoutline.svg" />
                                //                 </div>
                                //                 <div className="eye-icon">
                                //                     <img title="Revoke" src="/cancel.svg" alt="cancel.svg" />
                                //                 </div>
                                //             </div>
                                //         )
                                //     }
                                // }
                                return (
                                    <tr className="credentials-tr" style={{ animationDelay: `${index * 0.1}s` }} key={i.created_at}>
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.total_amount}</div>
                                        </td>
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.description}</div>
                                        </td>


                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.id}</div>
                                        </td>
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className={`credentials-table-text1 ${i.status=="PENDING"?"Pending":i.status=="COMPLETED"?"Complete":"Rejected"}`} style={{width:"auto"}}>{i.status}</div>
                                        </td>
                                    {User.user_type=="Issuer"?null:    <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.payment_method}</div>
                                        </td>}
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{setDate(i.created_at)}</div>
                                        </td>
                                    {User.user_type=="Issuer"?null:    <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.wallet_balance}</div>
                                        </td>}
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.transaction_mode=="CREDIT" && i.total_amount}</div>
                                        </td>
                                        <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            <div className="credentials-table-text1">{i.transaction_mode=="DEBIT" && i.total_amount}</div>
                                        </td>
                                    {User.user_type=="Issuer"?null:    <td className="credentials-td" style={{ justifyContent: 'flex-start', paddingLeft: '0rem' }}>
                                            {i.invoice_pdf ?<div className="credentials-table-text1" style={{cursor:"pointer"}} onClick={()=>setPreview(i.invoice_pdf)}><img alt="" src="/eyeoutline.svg" />
                                            </div>:i.status=="PENDING"?<div className="Pending" style={{width:"auto", height:"auto"}}>Transaction Pending</div>:i.status=="COMPLETED" && i.invoice_pdf==null && i.transaction_mode=="DEBIT"?<div className="Pending" style={{width:"auto", height:"auto"}}>Invoice Pending</div>:null}
                                        </td>}
                                    </tr>)
                            })}
                        </>
                    }
                </table>
            </div >
            <ReactPortalModal title={"Invoice PDF"} isOpen={invoicePreview} onClose={()=>setPreview(null)}>

                <DocPreview/>
            </ReactPortalModal>
        </>
    );
};

export default Records;
